import AirBar from "./AirBar.vue";
export default AirBar;
